// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-bell-container {
  position: relative;
}

.notification-panel-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  width: 360px;
  max-height: 480px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.notification-panel-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 0;
}

.notification-panel-fullscreen {
  width: 100%;
  height: 100%;
  max-height: none;
  border-radius: 0;
  background: white;
  display: flex;
  flex-direction: column;
}

.notification-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.notification-panel-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1a202c;
}

.notification-close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s ease;
}

.notification-close-button:hover {
  background: #edf2f7;
}

.notification-close-button svg {
  width: 20px;
  height: 20px;
  color: #718096;
}

.notification-panel-content {
  flex: 1;
  overflow-y: auto;
}

.notification-empty {
  padding: 40px 20px;
  text-align: center;
  color: #718096;
  font-size: 14px;
}

.notification-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.notification-item {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-item-content {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.notification-item-image {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}

.notification-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.notification-placeholder-image {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.notification-item-text {
  flex: 1;
  min-width: 0;
}

.notification-message {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #2d3748;
}

.notification-message strong {
  font-weight: 600;
}

.notification-item-actions {
  display: flex;
  gap: 8px;
}

.notification-action-button {
  flex: 1;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.notification-reject {
  background: white;
  border: 1px solid #e2e8f0;
  color: #4a5568;
}

.notification-reject:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
}

.notification-approve {
  background: #4299e1;
  border: 1px solid #4299e1;
  color: white;
}

.notification-approve:hover {
  background: #3182ce;
  border-color: #3182ce;
}

@media (max-width: 800px) {
  .notification-panel-dropdown {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    max-height: none;
    margin-top: 0;
    border-radius: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/NotificationBell.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;AACF","sourcesContent":[".notification-bell-container {\n  position: relative;\n}\n\n.notification-panel-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  width: 360px;\n  max-height: 480px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.notification-panel-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 0;\n}\n\n.notification-panel-fullscreen {\n  width: 100%;\n  height: 100%;\n  max-height: none;\n  border-radius: 0;\n  background: white;\n  display: flex;\n  flex-direction: column;\n}\n\n.notification-panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.notification-panel-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.notification-close-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.notification-close-button:hover {\n  background: #edf2f7;\n}\n\n.notification-close-button svg {\n  width: 20px;\n  height: 20px;\n  color: #718096;\n}\n\n.notification-panel-content {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.notification-empty {\n  padding: 40px 20px;\n  text-align: center;\n  color: #718096;\n  font-size: 14px;\n}\n\n.notification-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.notification-item {\n  padding: 16px 20px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.notification-item:last-child {\n  border-bottom: none;\n}\n\n.notification-item-content {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.notification-item-image {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.notification-item-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.notification-placeholder-image {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.notification-item-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-message {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #2d3748;\n}\n\n.notification-message strong {\n  font-weight: 600;\n}\n\n.notification-item-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.notification-action-button {\n  flex: 1;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.notification-reject {\n  background: white;\n  border: 1px solid #e2e8f0;\n  color: #4a5568;\n}\n\n.notification-reject:hover {\n  background: #f7fafc;\n  border-color: #cbd5e0;\n}\n\n.notification-approve {\n  background: #4299e1;\n  border: 1px solid #4299e1;\n  color: white;\n}\n\n.notification-approve:hover {\n  background: #3182ce;\n  border-color: #3182ce;\n}\n\n@media (max-width: 800px) {\n  .notification-panel-dropdown {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    max-height: none;\n    margin-top: 0;\n    border-radius: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
